// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Get-started — premium onboarding shell */

.gs-shell {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  font-family: Lato, sans-serif;
  background: #f1f4fa;
  overflow: hidden;
  z-index: 1;
}

.gs-brand-rail {
  width: min(420px, 38vw);
  flex-shrink: 0;
  align-self: stretch;
  background: linear-gradient(165deg, #00146d 0%, #011848 52%, #022a3a 100%);
  color: #e4eef0;
  display: flex;
  flex-direction: column;
  padding: 40px 36px;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.gs-brand-rail::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.35;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 40px 40px;
}

.gs-brand-glow {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(
    440px 260px at 0% 0%,
    rgba(13, 155, 135, 0.28),
    transparent 70%
  );
}

.gs-brand-inner {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: min-content;
}

.gs-steps {
  margin-top: auto;
  padding-top: 28px;
  padding-bottom: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  gap: 14px;
  flex-shrink: 0;
}

.gs-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 48px;
}

.gs-logo-mark {
  width: 44px;
  height: 44px;
  border-radius: 11px;
  overflow: hidden;
  display: grid;
  place-items: center;
  background: rgba(0, 0, 0, 0.28);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);
  flex-shrink: 0;
}

.gs-logo-mark img {
  height: 32px;
  width: 32px;
  object-fit: contain;
  display: block;
}

.gs-logo-name {
  font-family: Lato, sans-serif;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.12em;
  color: #fff;
  line-height: 1;
}

.gs-logo-sup {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.45);
  margin-left: -2px;
  align-self: flex-start;
  margin-top: 1px;
}

.gs-brand-eyebrow {
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #8da3ad;
  margin-bottom: 14px;
}

.gs-brand-headline {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -0.025em;
  line-height: 1.18;
  color: #fff;
  max-width: 12ch;
}

.gs-brand-body {
  margin: 16px 0 0;
  font-size: 16px;
  line-height: 1.55;
  color: #a9c0d0;
  max-width: 32ch;
}

.gs-step {
  display: flex;
  align-items: center;
  gap: 14px;
  opacity: 0.42;
  transition: opacity 0.2s;
}

.gs-step.is-active,
.gs-step.is-done {
  opacity: 1;
}

.gs-step-n {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 13px;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.08);
  color: #8da3ad;
  border: 1px solid rgba(255, 255, 255, 0.14);
  flex-shrink: 0;
}

.gs-step.is-active .gs-step-n,
.gs-step.is-done .gs-step-n {
  background: #0d9b87;
  color: #fff;
  border: none;
}

.gs-step-label {
  font-size: 15.5px;
  font-weight: 500;
  color: #8da3ad;
}

.gs-step.is-active .gs-step-label,
.gs-step.is-done .gs-step-label {
  font-weight: 700;
  color: #e4eef0;
}

.gs-main {
  flex: 1 1;
  min-width: 0;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  background: #f1f4fa;
  overflow: auto;
  position: relative;
}

.gs-main::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.45;
  background-image:
    linear-gradient(rgba(0, 20, 109, 0.035) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 20, 109, 0.035) 1px, transparent 1px);
  background-size: 46px 46px;
}

.gs-main-topbar {
  position: sticky;
  top: 0;
  z-index: 3;
  display: flex;
  justify-content: flex-end;
  padding: 16px 22px 0;
}

.gs-lang {
  display: inline-flex;
  align-items: center;
  padding: 3px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #dee4f0;
  box-shadow: 0 4px 14px -8px rgba(0, 20, 109, 0.35);
  gap: 2px;
}

.gs-lang-btn {
  height: 32px;
  min-width: 42px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #5b6b87;
  font-family: Lato, sans-serif;
  font-size: 12.5px;
  font-weight: 800;
  letter-spacing: 0.04em;
  cursor: pointer;
  width: auto !important;
  transition: background 0.14s, color 0.14s;
}

.gs-lang-btn:hover {
  color: #00146d;
}

.gs-lang-btn.is-active {
  background: #00146d;
  color: #fff;
}

.gs-mobile-brand {
  display: none;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: #00146d;
  position: relative;
  z-index: 1;
}

.gs-mobile-lang {
  margin-left: auto;
}

.gs-mobile-lang .gs-lang {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.14);
  box-shadow: none;
}

.gs-mobile-lang .gs-lang-btn {
  color: rgba(255, 255, 255, 0.65);
}

.gs-mobile-lang .gs-lang-btn.is-active {
  background: #0d9b87;
  color: #fff;
}

.gs-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 36px 36px 48px;
  box-sizing: border-box;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.gs-content.is-wide {
  max-width: 920px;
}

.gs-page-head {
  margin-bottom: 24px;
}

.gs-page-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 5px 11px 5px 5px;
  border-radius: 999px;
  background: #e2f7f2;
  border: 1px solid #c8ebe4;
  font-family: Lato, sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #076b5c;
}

.gs-page-eyebrow-dot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: #0d9b87;
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
}

.gs-page-title {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.2;
  background: linear-gradient(115deg, #00146d 0%, #00146d 42%, #0d9b87 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  max-width: 22ch;
}

.gs-page-title-bar {
  width: 44px;
  height: 4px;
  border-radius: 99px;
  margin-top: 14px;
  background: linear-gradient(90deg, #0d9b87, #4fe0c2);
}

.gs-page-sub {
  margin: 10px 0 0;
  font-family: Lato, sans-serif;
  font-size: 13.5px;
  color: #5b6b87;
  line-height: 1.5;
  max-width: 48ch;
}

.gs-panel {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  box-shadow: none;
}

/* ---- Wizard form ---- */

.gs-wiz-track {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 22px;
}

.gs-wiz-tab {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1.5px solid #dee4f0;
  background: #fff;
  cursor: pointer;
  text-align: left;
  width: 100% !important;
  font-family: Lato, sans-serif;
  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
}

.gs-wiz-tab:hover {
  border-color: #8b99b4;
}

.gs-wiz-tab.is-active {
  border-color: #0d9b87;
  background: #f2faf8;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);
}

.gs-wiz-tab.is-done:not(.is-active) {
  border-color: #c8ebe4;
  background: #f7fcfb;
}

.gs-wiz-tab-n {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  font-size: 12.5px;
  font-weight: 800;
  background: #eaeff7;
  color: #5b6b87;
  flex-shrink: 0;
}

.gs-wiz-tab.is-active .gs-wiz-tab-n {
  background: #0d9b87;
  color: #fff;
}

.gs-wiz-tab.is-done:not(.is-active) .gs-wiz-tab-n {
  background: #e2f7f2;
  color: #076b5c;
}

.gs-wiz-tab-copy {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.gs-wiz-tab-title {
  font-size: 12.5px;
  font-weight: 700;
  color: #0b1e2d;
  line-height: 1.2;
}

.gs-wiz-tab-hint {
  font-size: 11px;
  color: #8b99b4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gs-wiz-card {
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 16px;
  box-shadow: 0 18px 48px -30px rgba(0, 20, 109, 0.4);
  overflow: hidden;
  animation: gsFade 0.28s ease;
}

@keyframes gsFade {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.gs-wiz-card-head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #eaeff7;
  background: linear-gradient(180deg, #fafcfd 0%, #fff 100%);
}

.gs-wiz-card-ico {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: #e2f7f2;
  color: #076b5c;
  flex-shrink: 0;
}

.gs-wiz-card-ico svg {
  width: 22px;
  height: 22px;
}

.gs-wiz-card-head h3 {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #0b1e2d;
  letter-spacing: -0.01em;
}

.gs-wiz-card-head p {
  margin: 4px 0 0;
  font-size: 12.5px;
  color: #5b6b87;
  line-height: 1.45;
}

.gs-wiz-card-body {
  padding: 22px 24px 8px;
}

.gs-wiz-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.gs-wiz-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
}

.gs-wiz-field--span {
  grid-column: 1 / -1;
}

.gs-wiz-label {
  font-size: 12px;
  font-weight: 600;
  color: #0b1e2d;
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Lato, sans-serif;
}

.gs-wiz-req {
  color: #d14a3e;
}

.gs-wiz-inp {
  height: 40px;
  width: 100%;
  border: 1.5px solid #dee4f0;
  border-radius: 10px;
  padding: 0 12px;
  background: #f7f9fd;
  font-family: Lato, sans-serif;
  font-size: 13.5px;
  color: #0b1e2d;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
}

.gs-wiz-inp:hover {
  border-color: #8b99b4;
  background: #fff;
}

.gs-wiz-inp:focus {
  border-color: #0d9b87;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14);
}

.gs-wiz-inp.is-error {
  border-color: #d14a3e;
  background: #fff8f6;
}

.gs-wiz-inp.is-error:focus {
  box-shadow: 0 0 0 3px rgba(209, 74, 62, 0.12);
}

textarea.gs-wiz-inp {
  height: auto;
  min-height: 72px;
  padding: 10px 12px;
  resize: vertical;
  line-height: 1.45;
  font-size: 13.5px;
}

.gs-wiz-inp::placeholder {
  color: #8b99b4;
}

.gs-wiz-help {
  font-size: 11.5px;
  color: #8b99b4;
  line-height: 1.4;
}

.gs-wiz-err {
  font-size: 11.5px;
  color: #d14a3e;
  font-weight: 600;
}

.gs-wiz-pw-meter {
  display: flex;
  gap: 4px;
  margin-top: 2px;
}

.gs-wiz-pw-meter span {
  flex: 1 1;
  height: 3px;
  border-radius: 99px;
  background: #eaeff7;
  transition: background 0.2s;
}

.gs-wiz-pw-meter.s1 span:nth-child(1) {
  background: #d14a3e;
}

.gs-wiz-pw-meter.s2 span:nth-child(-n + 2) {
  background: #e6a817;
}

.gs-wiz-pw-meter.s3 span:nth-child(-n + 3) {
  background: #3b76d8;
}

.gs-wiz-pw-meter.s4 span {
  background: #0d9b87;
}

.gs-wiz-pw-rules {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
}

.gs-wiz-pw-rules span {
  font-size: 11px;
  color: #8b99b4;
  display: flex;
  align-items: center;
  gap: 4px;
}

.gs-wiz-pw-rules span::before {
  content: '';
  width: 4px;
  height: 4px;
  border-radius: 99px;
  background: currentColor;
}

.gs-wiz-pw-rules span.is-ok {
  color: #0e8271;
}

.gs-wiz-meter {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 24px;
  padding: 12px 0 4px;
}

.gs-wiz-meter-bar {
  flex: 1 1;
  height: 6px;
  border-radius: 99px;
  background: #eaeff7;
  overflow: hidden;
}

.gs-wiz-meter-fill {
  height: 100%;
  border-radius: 99px;
  background: linear-gradient(90deg, #0d9b87, #17a98f);
  transition: width 0.3s ease;
}

.gs-wiz-meter-label {
  font-size: 12.5px;
  font-weight: 700;
  color: #5b6b87;
  white-space: nowrap;
  font-family: Lato, sans-serif;
}

.gs-wiz-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 18px 24px 22px;
  border-top: 1px solid #eaeff7;
  background: #fafcfd;
  margin-top: 12px;
}

.gs-wiz-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 18px;
  border-radius: 10px;
  font-family: Lato, sans-serif;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  border: none;
  width: auto !important;
  transition: background 0.14s, border-color 0.14s, transform 0.14s;
}

.gs-wiz-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.gs-wiz-btn--ghost {
  background: #fff;
  color: #0b1e2d;
  border: 1.5px solid #dee4f0;
}

.gs-wiz-btn--ghost:hover:not(:disabled) {
  background: #f7f9fd;
  border-color: #8b99b4;
}

.gs-wiz-btn--primary {
  background: #00146d;
  color: #fff;
  box-shadow: 0 1px 2px rgba(0, 20, 109, 0.35);
  min-width: 160px;
}

.gs-wiz-btn--primary:hover:not(:disabled) {
  background: #1b2f8f;
}

.gs-wiz-btn--teal {
  background: #0d9b87;
  color: #fff;
  box-shadow: 0 1px 2px rgba(13, 155, 135, 0.35);
  min-width: 160px;
}

.gs-wiz-btn--teal:hover:not(:disabled) {
  background: #076b5c;
}

.gs-wiz-signin {
  margin-top: 18px;
  text-align: center;
  font-size: 13px;
  color: #5b6b87;
}

/* Country searchable select (react-select) — matches compact form type */
.gs-wiz-country .gs-react-select__control {
  min-height: 40px;
  border-radius: 10px;
  border-color: #dee4f0;
  border-width: 1.5px;
  background: #f7f9fd;
  box-shadow: none;
  font-family: Lato, sans-serif;
  font-size: 13.5px;
  cursor: pointer;
}

.gs-wiz-country .gs-react-select__control:hover {
  border-color: #8b99b4;
  background: #fff;
}

.gs-wiz-country .gs-react-select__control--is-focused {
  border-color: #0d9b87 !important;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14);
}

.gs-wiz-country.is-error .gs-react-select__control {
  border-color: #d14a3e;
  background: #fff8f6;
}

.gs-wiz-country .gs-react-select__value-container {
  padding: 2px 10px;
}

.gs-wiz-country .gs-react-select__placeholder,
.gs-wiz-country .gs-react-select__single-value,
.gs-wiz-country .gs-react-select__input-container {
  font-size: 13.5px;
  color: #0b1e2d;
  margin: 0;
}

.gs-wiz-country .gs-react-select__placeholder {
  color: #8b99b4;
}

.gs-wiz-country .gs-react-select__indicator-separator {
  display: none;
}

.gs-wiz-country .gs-react-select__dropdown-indicator {
  color: #5b6b87;
  padding: 0 10px;
}

.gs-wiz-country .gs-react-select__menu {
  border-radius: 10px;
  border: 1px solid #dee4f0;
  box-shadow: 0 16px 40px rgba(6, 21, 36, 0.14);
  overflow: hidden;
  z-index: 20;
  font-family: Lato, sans-serif;
  font-size: 13px;
}

.gs-wiz-country .gs-react-select__option {
  font-size: 13px;
  padding: 8px 12px;
  cursor: pointer;
}

.gs-wiz-country .gs-react-select__option--is-focused {
  background: #f7fafa;
  color: #0b1e2d;
}

.gs-wiz-country .gs-react-select__option--is-selected {
  background: #e2f7f2;
  color: #076b5c;
  font-weight: 600;
}

.gs-wiz-country .gs-react-select__menu-list {
  max-height: 240px;
  padding: 4px;
}

.gs-link {
  background: none;
  border: none;
  padding: 0;
  color: #00146d;
  font-weight: 700;
  font-size: inherit;
  font-family: Lato, sans-serif;
  cursor: pointer;
  width: auto !important;
}

.gs-link:hover {
  color: #0e8271;
}

.gs-alert {
  margin-bottom: 16px;
  padding: 12px 14px;
  border-radius: 10px;
  background: #fae6e3;
  border: 1px solid #f0c9c3;
  color: #96271b;
  font-size: 14px;
  line-height: 1.45;
}

@media (max-width: 900px) {
  .gs-brand-rail {
    display: none !important;
  }

  .gs-mobile-brand {
    display: flex !important;
  }

  .gs-main-topbar {
    display: none;
  }

  .gs-content {
    padding: 24px 16px 36px;
  }

  .gs-page-title {
    font-size: 22px;
    max-width: none;
  }

  .gs-wiz-track {
    grid-template-columns: 1fr;
  }

  .gs-wiz-grid {
    grid-template-columns: 1fr;
  }

  .gs-wiz-card-head,
  .gs-wiz-card-body,
  .gs-wiz-foot {
    padding-left: 18px;
    padding-right: 18px;
  }

  .gs-wiz-meter {
    margin-left: 18px;
    margin-right: 18px;
  }

  .gs-wiz-foot {
    flex-direction: column-reverse;
  }

  .gs-wiz-btn--primary,
  .gs-wiz-btn--teal,
  .gs-wiz-btn--ghost {
    width: 100% !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/getStarted/getStarted.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,0EAA0E;EAC1E,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb;;0EAEwE;EACxE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB;;;;GAIC;AACH;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,wBAAwB;AAC1B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;EACd,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb;;wEAEsE;EACtE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kDAAkD;EAClD,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kDAAkD;EAClD,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,0EAA0E;EAC1E,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA,0BAA0B;;AAE1B;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mDAAmD;EACnD,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,yEAAyE;AACzE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;;IAGE,sBAAsB;EACxB;AACF","sourcesContent":["/* Get-started — premium onboarding shell */\n\n.gs-shell {\n  position: fixed;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  font-family: Lato, sans-serif;\n  background: #f1f4fa;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.gs-brand-rail {\n  width: min(420px, 38vw);\n  flex-shrink: 0;\n  align-self: stretch;\n  background: linear-gradient(165deg, #00146d 0%, #011848 52%, #022a3a 100%);\n  color: #e4eef0;\n  display: flex;\n  flex-direction: column;\n  padding: 40px 36px;\n  position: relative;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.gs-brand-rail::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.35;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);\n  background-size: 40px 40px;\n}\n\n.gs-brand-glow {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background: radial-gradient(\n    440px 260px at 0% 0%,\n    rgba(13, 155, 135, 0.28),\n    transparent 70%\n  );\n}\n\n.gs-brand-inner {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: min-content;\n}\n\n.gs-steps {\n  margin-top: auto;\n  padding-top: 28px;\n  padding-bottom: 8px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  flex-shrink: 0;\n}\n\n.gs-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 48px;\n}\n\n.gs-logo-mark {\n  width: 44px;\n  height: 44px;\n  border-radius: 11px;\n  overflow: hidden;\n  display: grid;\n  place-items: center;\n  background: rgba(0, 0, 0, 0.28);\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.14);\n  flex-shrink: 0;\n}\n\n.gs-logo-mark img {\n  height: 32px;\n  width: 32px;\n  object-fit: contain;\n  display: block;\n}\n\n.gs-logo-name {\n  font-family: Lato, sans-serif;\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  color: #fff;\n  line-height: 1;\n}\n\n.gs-logo-sup {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.45);\n  margin-left: -2px;\n  align-self: flex-start;\n  margin-top: 1px;\n}\n\n.gs-brand-eyebrow {\n  font-size: 12.5px;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #8da3ad;\n  margin-bottom: 14px;\n}\n\n.gs-brand-headline {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 32px;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  line-height: 1.18;\n  color: #fff;\n  max-width: 12ch;\n}\n\n.gs-brand-body {\n  margin: 16px 0 0;\n  font-size: 16px;\n  line-height: 1.55;\n  color: #a9c0d0;\n  max-width: 32ch;\n}\n\n.gs-step {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  opacity: 0.42;\n  transition: opacity 0.2s;\n}\n\n.gs-step.is-active,\n.gs-step.is-done {\n  opacity: 1;\n}\n\n.gs-step-n {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  font-size: 13px;\n  font-weight: 800;\n  background: rgba(255, 255, 255, 0.08);\n  color: #8da3ad;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  flex-shrink: 0;\n}\n\n.gs-step.is-active .gs-step-n,\n.gs-step.is-done .gs-step-n {\n  background: #0d9b87;\n  color: #fff;\n  border: none;\n}\n\n.gs-step-label {\n  font-size: 15.5px;\n  font-weight: 500;\n  color: #8da3ad;\n}\n\n.gs-step.is-active .gs-step-label,\n.gs-step.is-done .gs-step-label {\n  font-weight: 700;\n  color: #e4eef0;\n}\n\n.gs-main {\n  flex: 1;\n  min-width: 0;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  background: #f1f4fa;\n  overflow: auto;\n  position: relative;\n}\n\n.gs-main::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  opacity: 0.45;\n  background-image:\n    linear-gradient(rgba(0, 20, 109, 0.035) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(0, 20, 109, 0.035) 1px, transparent 1px);\n  background-size: 46px 46px;\n}\n\n.gs-main-topbar {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 22px 0;\n}\n\n.gs-lang {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px;\n  border-radius: 10px;\n  background: #fff;\n  border: 1px solid #dee4f0;\n  box-shadow: 0 4px 14px -8px rgba(0, 20, 109, 0.35);\n  gap: 2px;\n}\n\n.gs-lang-btn {\n  height: 32px;\n  min-width: 42px;\n  padding: 0 12px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #5b6b87;\n  font-family: Lato, sans-serif;\n  font-size: 12.5px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  cursor: pointer;\n  width: auto !important;\n  transition: background 0.14s, color 0.14s;\n}\n\n.gs-lang-btn:hover {\n  color: #00146d;\n}\n\n.gs-lang-btn.is-active {\n  background: #00146d;\n  color: #fff;\n}\n\n.gs-mobile-brand {\n  display: none;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  background: #00146d;\n  position: relative;\n  z-index: 1;\n}\n\n.gs-mobile-lang {\n  margin-left: auto;\n}\n\n.gs-mobile-lang .gs-lang {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.14);\n  box-shadow: none;\n}\n\n.gs-mobile-lang .gs-lang-btn {\n  color: rgba(255, 255, 255, 0.65);\n}\n\n.gs-mobile-lang .gs-lang-btn.is-active {\n  background: #0d9b87;\n  color: #fff;\n}\n\n.gs-content {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: 680px;\n  margin: 0 auto;\n  padding: 36px 36px 48px;\n  box-sizing: border-box;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.gs-content.is-wide {\n  max-width: 920px;\n}\n\n.gs-page-head {\n  margin-bottom: 24px;\n}\n\n.gs-page-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 12px;\n  padding: 5px 11px 5px 5px;\n  border-radius: 999px;\n  background: #e2f7f2;\n  border: 1px solid #c8ebe4;\n  font-family: Lato, sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #076b5c;\n}\n\n.gs-page-eyebrow-dot {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  background: #0d9b87;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.gs-page-title {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 24px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.2;\n  background: linear-gradient(115deg, #00146d 0%, #00146d 42%, #0d9b87 100%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  max-width: 22ch;\n}\n\n.gs-page-title-bar {\n  width: 44px;\n  height: 4px;\n  border-radius: 99px;\n  margin-top: 14px;\n  background: linear-gradient(90deg, #0d9b87, #4fe0c2);\n}\n\n.gs-page-sub {\n  margin: 10px 0 0;\n  font-family: Lato, sans-serif;\n  font-size: 13.5px;\n  color: #5b6b87;\n  line-height: 1.5;\n  max-width: 48ch;\n}\n\n.gs-panel {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  box-shadow: none;\n}\n\n/* ---- Wizard form ---- */\n\n.gs-wiz-track {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n  margin-bottom: 22px;\n}\n\n.gs-wiz-tab {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1.5px solid #dee4f0;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  width: 100% !important;\n  font-family: Lato, sans-serif;\n  transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;\n}\n\n.gs-wiz-tab:hover {\n  border-color: #8b99b4;\n}\n\n.gs-wiz-tab.is-active {\n  border-color: #0d9b87;\n  background: #f2faf8;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);\n}\n\n.gs-wiz-tab.is-done:not(.is-active) {\n  border-color: #c8ebe4;\n  background: #f7fcfb;\n}\n\n.gs-wiz-tab-n {\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  display: grid;\n  place-items: center;\n  font-size: 12.5px;\n  font-weight: 800;\n  background: #eaeff7;\n  color: #5b6b87;\n  flex-shrink: 0;\n}\n\n.gs-wiz-tab.is-active .gs-wiz-tab-n {\n  background: #0d9b87;\n  color: #fff;\n}\n\n.gs-wiz-tab.is-done:not(.is-active) .gs-wiz-tab-n {\n  background: #e2f7f2;\n  color: #076b5c;\n}\n\n.gs-wiz-tab-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.gs-wiz-tab-title {\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #0b1e2d;\n  line-height: 1.2;\n}\n\n.gs-wiz-tab-hint {\n  font-size: 11px;\n  color: #8b99b4;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.gs-wiz-card {\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 16px;\n  box-shadow: 0 18px 48px -30px rgba(0, 20, 109, 0.4);\n  overflow: hidden;\n  animation: gsFade 0.28s ease;\n}\n\n@keyframes gsFade {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.gs-wiz-card-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 22px 24px 18px;\n  border-bottom: 1px solid #eaeff7;\n  background: linear-gradient(180deg, #fafcfd 0%, #fff 100%);\n}\n\n.gs-wiz-card-ico {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  background: #e2f7f2;\n  color: #076b5c;\n  flex-shrink: 0;\n}\n\n.gs-wiz-card-ico svg {\n  width: 22px;\n  height: 22px;\n}\n\n.gs-wiz-card-head h3 {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0b1e2d;\n  letter-spacing: -0.01em;\n}\n\n.gs-wiz-card-head p {\n  margin: 4px 0 0;\n  font-size: 12.5px;\n  color: #5b6b87;\n  line-height: 1.45;\n}\n\n.gs-wiz-card-body {\n  padding: 22px 24px 8px;\n}\n\n.gs-wiz-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.gs-wiz-field {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  min-width: 0;\n}\n\n.gs-wiz-field--span {\n  grid-column: 1 / -1;\n}\n\n.gs-wiz-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #0b1e2d;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-family: Lato, sans-serif;\n}\n\n.gs-wiz-req {\n  color: #d14a3e;\n}\n\n.gs-wiz-inp {\n  height: 40px;\n  width: 100%;\n  border: 1.5px solid #dee4f0;\n  border-radius: 10px;\n  padding: 0 12px;\n  background: #f7f9fd;\n  font-family: Lato, sans-serif;\n  font-size: 13.5px;\n  color: #0b1e2d;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;\n}\n\n.gs-wiz-inp:hover {\n  border-color: #8b99b4;\n  background: #fff;\n}\n\n.gs-wiz-inp:focus {\n  border-color: #0d9b87;\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14);\n}\n\n.gs-wiz-inp.is-error {\n  border-color: #d14a3e;\n  background: #fff8f6;\n}\n\n.gs-wiz-inp.is-error:focus {\n  box-shadow: 0 0 0 3px rgba(209, 74, 62, 0.12);\n}\n\ntextarea.gs-wiz-inp {\n  height: auto;\n  min-height: 72px;\n  padding: 10px 12px;\n  resize: vertical;\n  line-height: 1.45;\n  font-size: 13.5px;\n}\n\n.gs-wiz-inp::placeholder {\n  color: #8b99b4;\n}\n\n.gs-wiz-help {\n  font-size: 11.5px;\n  color: #8b99b4;\n  line-height: 1.4;\n}\n\n.gs-wiz-err {\n  font-size: 11.5px;\n  color: #d14a3e;\n  font-weight: 600;\n}\n\n.gs-wiz-pw-meter {\n  display: flex;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n.gs-wiz-pw-meter span {\n  flex: 1;\n  height: 3px;\n  border-radius: 99px;\n  background: #eaeff7;\n  transition: background 0.2s;\n}\n\n.gs-wiz-pw-meter.s1 span:nth-child(1) {\n  background: #d14a3e;\n}\n\n.gs-wiz-pw-meter.s2 span:nth-child(-n + 2) {\n  background: #e6a817;\n}\n\n.gs-wiz-pw-meter.s3 span:nth-child(-n + 3) {\n  background: #3b76d8;\n}\n\n.gs-wiz-pw-meter.s4 span {\n  background: #0d9b87;\n}\n\n.gs-wiz-pw-rules {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 10px;\n}\n\n.gs-wiz-pw-rules span {\n  font-size: 11px;\n  color: #8b99b4;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.gs-wiz-pw-rules span::before {\n  content: '';\n  width: 4px;\n  height: 4px;\n  border-radius: 99px;\n  background: currentColor;\n}\n\n.gs-wiz-pw-rules span.is-ok {\n  color: #0e8271;\n}\n\n.gs-wiz-meter {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 0 24px;\n  padding: 12px 0 4px;\n}\n\n.gs-wiz-meter-bar {\n  flex: 1;\n  height: 6px;\n  border-radius: 99px;\n  background: #eaeff7;\n  overflow: hidden;\n}\n\n.gs-wiz-meter-fill {\n  height: 100%;\n  border-radius: 99px;\n  background: linear-gradient(90deg, #0d9b87, #17a98f);\n  transition: width 0.3s ease;\n}\n\n.gs-wiz-meter-label {\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #5b6b87;\n  white-space: nowrap;\n  font-family: Lato, sans-serif;\n}\n\n.gs-wiz-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 18px 24px 22px;\n  border-top: 1px solid #eaeff7;\n  background: #fafcfd;\n  margin-top: 12px;\n}\n\n.gs-wiz-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 40px;\n  padding: 0 18px;\n  border-radius: 10px;\n  font-family: Lato, sans-serif;\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n  border: none;\n  width: auto !important;\n  transition: background 0.14s, border-color 0.14s, transform 0.14s;\n}\n\n.gs-wiz-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.gs-wiz-btn--ghost {\n  background: #fff;\n  color: #0b1e2d;\n  border: 1.5px solid #dee4f0;\n}\n\n.gs-wiz-btn--ghost:hover:not(:disabled) {\n  background: #f7f9fd;\n  border-color: #8b99b4;\n}\n\n.gs-wiz-btn--primary {\n  background: #00146d;\n  color: #fff;\n  box-shadow: 0 1px 2px rgba(0, 20, 109, 0.35);\n  min-width: 160px;\n}\n\n.gs-wiz-btn--primary:hover:not(:disabled) {\n  background: #1b2f8f;\n}\n\n.gs-wiz-btn--teal {\n  background: #0d9b87;\n  color: #fff;\n  box-shadow: 0 1px 2px rgba(13, 155, 135, 0.35);\n  min-width: 160px;\n}\n\n.gs-wiz-btn--teal:hover:not(:disabled) {\n  background: #076b5c;\n}\n\n.gs-wiz-signin {\n  margin-top: 18px;\n  text-align: center;\n  font-size: 13px;\n  color: #5b6b87;\n}\n\n/* Country searchable select (react-select) — matches compact form type */\n.gs-wiz-country .gs-react-select__control {\n  min-height: 40px;\n  border-radius: 10px;\n  border-color: #dee4f0;\n  border-width: 1.5px;\n  background: #f7f9fd;\n  box-shadow: none;\n  font-family: Lato, sans-serif;\n  font-size: 13.5px;\n  cursor: pointer;\n}\n\n.gs-wiz-country .gs-react-select__control:hover {\n  border-color: #8b99b4;\n  background: #fff;\n}\n\n.gs-wiz-country .gs-react-select__control--is-focused {\n  border-color: #0d9b87 !important;\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.14);\n}\n\n.gs-wiz-country.is-error .gs-react-select__control {\n  border-color: #d14a3e;\n  background: #fff8f6;\n}\n\n.gs-wiz-country .gs-react-select__value-container {\n  padding: 2px 10px;\n}\n\n.gs-wiz-country .gs-react-select__placeholder,\n.gs-wiz-country .gs-react-select__single-value,\n.gs-wiz-country .gs-react-select__input-container {\n  font-size: 13.5px;\n  color: #0b1e2d;\n  margin: 0;\n}\n\n.gs-wiz-country .gs-react-select__placeholder {\n  color: #8b99b4;\n}\n\n.gs-wiz-country .gs-react-select__indicator-separator {\n  display: none;\n}\n\n.gs-wiz-country .gs-react-select__dropdown-indicator {\n  color: #5b6b87;\n  padding: 0 10px;\n}\n\n.gs-wiz-country .gs-react-select__menu {\n  border-radius: 10px;\n  border: 1px solid #dee4f0;\n  box-shadow: 0 16px 40px rgba(6, 21, 36, 0.14);\n  overflow: hidden;\n  z-index: 20;\n  font-family: Lato, sans-serif;\n  font-size: 13px;\n}\n\n.gs-wiz-country .gs-react-select__option {\n  font-size: 13px;\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.gs-wiz-country .gs-react-select__option--is-focused {\n  background: #f7fafa;\n  color: #0b1e2d;\n}\n\n.gs-wiz-country .gs-react-select__option--is-selected {\n  background: #e2f7f2;\n  color: #076b5c;\n  font-weight: 600;\n}\n\n.gs-wiz-country .gs-react-select__menu-list {\n  max-height: 240px;\n  padding: 4px;\n}\n\n.gs-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #00146d;\n  font-weight: 700;\n  font-size: inherit;\n  font-family: Lato, sans-serif;\n  cursor: pointer;\n  width: auto !important;\n}\n\n.gs-link:hover {\n  color: #0e8271;\n}\n\n.gs-alert {\n  margin-bottom: 16px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #fae6e3;\n  border: 1px solid #f0c9c3;\n  color: #96271b;\n  font-size: 14px;\n  line-height: 1.45;\n}\n\n@media (max-width: 900px) {\n  .gs-brand-rail {\n    display: none !important;\n  }\n\n  .gs-mobile-brand {\n    display: flex !important;\n  }\n\n  .gs-main-topbar {\n    display: none;\n  }\n\n  .gs-content {\n    padding: 24px 16px 36px;\n  }\n\n  .gs-page-title {\n    font-size: 22px;\n    max-width: none;\n  }\n\n  .gs-wiz-track {\n    grid-template-columns: 1fr;\n  }\n\n  .gs-wiz-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .gs-wiz-card-head,\n  .gs-wiz-card-body,\n  .gs-wiz-foot {\n    padding-left: 18px;\n    padding-right: 18px;\n  }\n\n  .gs-wiz-meter {\n    margin-left: 18px;\n    margin-right: 18px;\n  }\n\n  .gs-wiz-foot {\n    flex-direction: column-reverse;\n  }\n\n  .gs-wiz-btn--primary,\n  .gs-wiz-btn--teal,\n  .gs-wiz-btn--ghost {\n    width: 100% !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
